export const EmojiExampleList = [
    "🤭", "😄", "😁", "😆", "😅", "😂", "🤣", "😊", "😇",
    "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘", "😗", "😙", "😚",
    "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔",
    "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "😔",
    "😪", "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🤧", "😵", "🤯",
    "😳", "🥵", "🥶", "😱", "😨", "😰", "😥", "😢", "😭", "😤",
    "😠", "😡", "🤬", "🤯", "😳", "🥱", "😤",
]


export const KaomojiExampleList = [
    "(＾▽＾)", "(≧▽≦)", "(´▽｀)", "(๑˃ᴗ˂)ﻭ", "(￣▽￣)ノ",
    "(＊^▽^*)", "(^‿^)", "(＾ω＾)", "(o^∀^o)", "(≧ω≦)",
    "(o´▽`o)", "(＠＾－＾)", "(≧∇≦)ﾉ", "(*´▽`*)", "(＾-＾)v",
    "(ヽ*＾ω＾*)ﾉ", "(๑´ڡ`๑)", "( •̀ ω •́ )✧", "(*＾3＾)/～☆",
    "(≧∇≦)/", "(｡♥‿♥｡)", "(｡•ㅅ•｡)♡", "(｡･ω･｡)ﾉ♡", "(ฅ•ω•ฅ)♡",
    "(๑•́ ₃ •̀๑)", "(´・ω・`)", "(｡•́︿•̀｡)", "(｡♥‿♥｡)",
    "(*≧ω≦)", "(∩_∩)", "(￣3￣)", "(๑°3°๑)", "(,,• •,,)♡",
    "(｡・//ε//・｡)", "(づ￣ ³￣)づ", "(´∀｀)♡", "( ˘ ³˘)♥",
    "(๑´•.̫ • `๑)", "(づ｡◕‿‿◕｡)づ", "(´,,•ω•,,｀)♡", "(〃ω〃)",
    "(⁄ ⁄•⁄ω⁄•⁄ ⁄)", "(｡･//ω//･｡)", "(*ﾉωﾉ)", "(´//ω//｀)",
    "(*ฅ́˘ฅ̀*)", "(*/ω＼*)", "(๑•́‧̫•̀๑)", "(´,,•ω•,,｀)",
    "(//▽//)", "(｡•́︿•̀｡)", "(T_T)", "(ಥ_ಥ)",
    "(இ﹏இ`｡)", "(〒︿〒)", "(╯︵╰,)", "(ಥ﹏ಥ)", "(｡•́︿•̀｡)",
    "(ノ_・。)", "(´；д；`)", "(；′⌒`)", "(つω`｡)", "(ᗒᗩᗕ)",
    "(｡•́︿•̀｡)", "(╥﹏╥)", "(ಥ_ಥ)", "｡：ﾟ(｡ﾉω＼｡)ﾟ･｡", "(つд⊂)",
    "(╥ω╥)", "(＃｀皿´)", "(￣へ￣)", "(≧ヘ≦ )", "(눈_눈)", "(¬_¬)",
    "(╬ಠ益ಠ)", "(｡•ˇ‸ˇ•｡)", "(｀⌒´メ)", "(⇀‸↼‶)", "(¬‿¬)",
    "(°ロ°) !?", "(・o・)", "(๑•̀ㅁ•́๑)", "(⊙_◎)", "Σ(°ロ°)",
    "(°ー°〃)", "Σ(￣□￣||)", "(⊙＿⊙')", "(☉｡☉)!", "(o_O)",
    "(￣ー￣)", "(￢_￢)", "(≖_≖ )", "( ´_ゝ`)", "(ಠ_ಠ)", "(；￣Д￣)",
];
